const OtpInput = ({otpCode, onChange, onKeyDown, onPaste, inputRefs, disabled}) => (
    <div className='mfa-otp-inputs'>
        {otpCode.map((digit, index) => (
            <input
                key={index}
                ref={el => inputRefs.current[index] = el}
                type='text'
                inputMode='numeric'
                maxLength={1}
                value={digit}
                onChange={e => onChange(index, e.target.value)}
                onKeyDown={e => onKeyDown(index, e)}
                onPaste={index === 0 ? onPaste : undefined}
                className='mfa-otp-input'
                disabled={disabled}
                autoFocus={index === 0}
            />
        ))}
    </div>
)

export default OtpInput
